import { AdminRouteName } from '../../../CONSTANTS';
import RentCollectionTableRecords from '../RentCollectionTableRecords';

const PendingPaymentRentCollection = () => (
  <RentCollectionTableRecords
    defaultUrl={AdminRouteName.rentCollectionPendingPayment}
    toggleStorageId="pending_rent-collection-table-col"
    optionalColumn={['paymentStatus']}
    optionalColumnLabelFormat={{
      paymentStatus: 'Payment status',
      status: 'Settlement status',
    }}
    hasNameAndImage
    permissionName="can-view-pending-rent-payment"
    tabStatus="PENDING"
  />
);
export default PendingPaymentRentCollection;
